export function EllipsisIcon({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M7 8.3125C7.72487 8.3125 8.3125 7.72487 8.3125 7C8.3125 6.27513 7.72487 5.6875 7 5.6875C6.27513 5.6875 5.6875 6.27513 5.6875 7C5.6875 7.72487 6.27513 8.3125 7 8.3125Z"
        fill={color || "currentColor"}
      />
      <path
        d="M7 12.6875C7.72487 12.6875 8.3125 12.0999 8.3125 11.375C8.3125 10.6501 7.72487 10.0625 7 10.0625C6.27513 10.0625 5.6875 10.6501 5.6875 11.375C5.6875 12.0999 6.27513 12.6875 7 12.6875Z"
        fill={color || "currentColor"}
      />
      <path
        d="M7 3.9375C7.72487 3.9375 8.3125 3.34987 8.3125 2.625C8.3125 1.90013 7.72487 1.3125 7 1.3125C6.27513 1.3125 5.6875 1.90013 5.6875 2.625C5.6875 3.34987 6.27513 3.9375 7 3.9375Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
}
